<script>
  import { onDestroy } from 'svelte';
  import { getStores } from '$app/stores';
  import { browser } from '$app/environment';
  import heapSetup from './heapSetup';

  const { page } = getStores();
  const apiKey = $page.data.session.env.HEAP_IO_API_KEY;

  if (browser) {
    // eslint-disable-next-line logical-assignment-operators
    window.heap = window.heap || [];
    window.heap.load = heapSetup;
    window.heap.load(apiKey);

    onDestroy(page.subscribe(async ({ data: { session: { user } } }) => {
      const organization = user?.organizations.sort()[0];
      const identification = {
        bearId: user?.id,
        name: `${user?.givenName} ${user?.familyName}`,
        role: user?.role,
        email: user?.email,
        organizationId: organization?.id,
        organizationName: organization?.name,
        commercebearEmployee: user?.email.endsWith('@commercebear.com'),
      };
      window.heap.identify(user.email);
      window.heap.addUserProperties(identification);
    }));
  }
</script>

<!-- PRD-674 Heap's script constantly changes, which sucks.  If they ever give us a consistent script, we should set integrity here -->
<svelte:head>
  {#if browser}
    <script
      async
      src='https://cdn.heapanalytics.com/js/heap-{apiKey}.js'
    ></script>
  {/if}
</svelte:head>
